import { createAppAsyncThunk } from '@/redux/create-app-thunk';
import { redirectToPaymentProvider } from '@/redux/thunks/checkout/index';

export const processPayment = createAppAsyncThunk(
  'checkout/processPayment',
  async (_, { getState, rejectWithValue, extra: { checkoutService } }) => {
    const cart = getState().cart.content;
    try {
      return await checkoutService.processPayment({ cart });
    } catch (error) {
      await redirectToPaymentProvider('/checkout/pay');
      return rejectWithValue(error);
    }
  }
);
